<template>
  <div class="scroll-bg ei-long-figure-scroll3">
    <div class="scroll-l"></div>
    <div class="scroll-l" style="z-index: 1"></div>
    <div class="scroll-r"></div>
    <div class="scroll-r" style="z-index: 1"></div>
    <div class="container">
      <div class="scroll-inline-container">
        <div class="scroll-container">
          <img :src="url">
          <img :src="url">
          <img :src="url">
          <img :src="url">
        </div>
        <div class="scroll-container">
          <img :src="url">
          <img :src="url">
          <img :src="url">
          <img :src="url">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EiLongFigureScroll3',
  data () {
    return {
      duration: 0,
    }
  },
  props: {
    url: {
      type: String,
      required: true
    },
    width: {
      type: Number,
      required: true
    },
    speed: {
      type: Number,
      default: 300
    }

  },
  methods:{
   /* initKeyframes_Bg() {
      let startX =1180 - this.width
      let endX =1180
      this.duration = (endX - startX)  / this.speed
      let style = document.createElement('style')
      document.getElementsByTagName('head')[0].appendChild(style)
      style.appendChild(document.createTextNode(''))
      document.styleSheets[document.styleSheets.length - 1].insertRule(`
            @keyframes scroll{
               0%{transform: translateX(${startX}px);}
               100%{transform: translateX(${endX}px);}
            }`)
    },*/
  },
  mounted () {
   /* this.initKeyframes_Bg()*/
   /* let startX = 1180 - this.width
    let endX = 1180 + this.width
    this.duration = parseInt(this.width / this.speed)
    let style = document.createElement('style')
    document.getElementsByTagName('head')[0].appendChild(style)
    style.appendChild(document.createTextNode(''))
    document.styleSheets[document.styleSheets.length - 1].insertRule(`
            @keyframes scroll{
                0%{background-position-x: ${startX}px;}
                100%{ background-position-x: ${endX}px;}
            }`)*/
  }
}
</script>

<style scoped lang="scss">
$outWidth: 1175px;
div {
  box-sizing: border-box;
}

.scroll-bg {
  position: relative;
  display: inline-block;
  width: $outWidth+30;
  height: 578px;
}


.scroll-l {
  position: absolute;
  width: 66px;
  height: 580px;
  background-image: url("./image/longscroll-l.png");
  background-size: auto 100%;
  background-repeat: no-repeat;
  opacity: 0.7;
  z-index: 3;
}

.scroll-r {
  position: absolute;
  top: 0;
  right: 25px;
  width: 60px;
  height: 583px;
  background-image: url("./image/longscroll-r.png");
  background-repeat: no-repeat;
  background-size: auto 100%;
  opacity: 0.7;
  z-index: 3;
}
.container {
  margin-top: 90px;
  width: 1175px;
  height: 400px;
  display: inline-block;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, .6);
}

.scroll-inline-container {
  white-space: nowrap;
  overflow-x: scroll;
}

.scroll-container {
  z-index: 2;
  display: inline-block;
  animation: infiniteScroll 180s linear infinite;
}

.scroll-container img {
  width: 3473px;
  height: 400px;
  margin-left: -1px;
}

@keyframes infiniteScroll {
  0% {
    transform: translate3d(-100%,0,0);
  }
  100% {
    transform: translate3d(0,0,0);
  }
}

.scroll-content:hover {
  animation-play-state: paused;
}
</style>
